import React, { Component } from "react";
import { Link } from "react-router-dom";
import LayoutWrapper from "../LayoutWrapper";
import DownloadReportModal from "./DownloadReportModal";
import IncompleteAssessmentModal from "./IncompleteAssessmentModal";
import ReportsScheduledModal from "./ReportsScheduledModal";
import SelectYearModal from "./SelectYearModal";
import Select from "react-dropdown-select";

export class ViewEditScore extends Component {
  constructor(props) {
    super(props);
    if (props.initialconstruct) {
      props.initialconstruct.bind(this)("ViewEditScore");
    }
    this.state = {
      loader: false,
      isGeneratingReport: false,
      hasSuperAdminGenerated: false,
      scheduledTerms: {},
      data: null,
      selectedStudentIds: [],
      sortConfig: { key: null, parameterId: null, direction: 'asc' },
      role: "",
    };
    this.paramColors = [
      { bg: '#fff0bd', text: '#b58500', colBg: '#fff7da' },
      { bg: '#e6efff', text: '#0f52ba', colBg: '#f0f5ff' },
      { bg: '#efebff', text: '#551a8b', colBg: '#f6f4ff' },
      { bg: '#ffe6eb', text: '#a52a2a', colBg: '#fff0f2' },
    ];
  }

  componentDidMount() {
    this.fetchData();
    let currentAdminRole = localStorage.getItem("currentAdminRole");
    this.setState({ role: currentAdminRole });
  }

  requestSort = (key, parameterId = null) => {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.parameterId === parameterId && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, parameterId, direction } });
  };

  fetchData = () => {
    let { id } = this.props.urlparams || {};
    if (id) {
      this.setState({ loader: true });
      this.props.api.apiGetOfflineAssessmentSectionById({ id })
        .then((res) => {
          this.setState({ data: res.data, loader: false });
        })
        .catch(() => this.setState({ loader: false }));
    }
  };

  handleMarkChange = (studentId, parameterId, field, value) => {
    if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;

    let val = value === "" ? null : value;
    let numVal = val !== null ? Number(val) : null;

    let parameters = this.state.data?.offlineAssessmentSection?.offline_assessment?.parameters || [];
    let param = parameters.find(p => p._id === parameterId);
    let maxMark = param ? Number(param.maxMark) : null;

    if (numVal !== null && maxMark !== null && numVal > maxMark) {
      window.error(`Marks cannot exceed the maximum of ${maxMark}`);
      return;
    }

    this.setState((prevState) => {
      let newData = { ...prevState.data };
      let students = [...newData.students];
      let studentIndex = students.findIndex(s => s._id === studentId);
      if (studentIndex > -1) {
        let student = { ...students[studentIndex] };
        let marks = [...(student.marks || [])];
        let markIndex = marks.findIndex(m => m.parameter_id === parameterId);

        if (markIndex > -1) {
          marks[markIndex] = { ...marks[markIndex], [field]: val };
        } else {
          marks.push({ parameter_id: parameterId, [field]: val });
        }

        // Recalculate average for this mark
        let m = marks[markIndex > -1 ? markIndex : marks.length - 1];
        let h = m.half_yearly_marks !== undefined && m.half_yearly_marks !== null && m.half_yearly_marks !== "" && !isNaN(Number(m.half_yearly_marks)) ? Number(m.half_yearly_marks) : null;
        let y = m.yearly_marks !== undefined && m.yearly_marks !== null && m.yearly_marks !== "" && !isNaN(Number(m.yearly_marks)) ? Number(m.yearly_marks) : null;

        if (h !== null && y !== null) m.average_marks = (h + y) / 2;
        else if (h !== null) m.average_marks = h;
        else if (y !== null) m.average_marks = y;
        else m.average_marks = null;

        // Recalculate totals for student
        let totalH = null;
        let totalY = null;
        marks.forEach(mk => {
          if (mk.half_yearly_marks !== undefined && mk.half_yearly_marks !== null && mk.half_yearly_marks !== "" && !isNaN(Number(mk.half_yearly_marks))) {
            totalH = (totalH || 0) + Number(mk.half_yearly_marks);
          }
          if (mk.yearly_marks !== undefined && mk.yearly_marks !== null && mk.yearly_marks !== "" && !isNaN(Number(mk.yearly_marks))) {
            totalY = (totalY || 0) + Number(mk.yearly_marks);
          }
        });

        student.total_half_yearly = totalH;
        student.total_yearly = totalY;

        student.marks = marks;
        students[studentIndex] = student;
        newData.students = students;
      }
      return { data: newData };
    });
  };

  handleSave = () => {
    let { data } = this.state;
    if (!data) return;

    let sectionData = data.offlineAssessmentSection;
    let studentsMarks = [];

    data.students.forEach(student => {
      if (student.marks && student.marks.length > 0) {
        student.marks.forEach(mark => {
          let markEntry = {
            _id: student._id,
            profile_id: student.profile_id,
            parameter_id: mark.parameter_id
          };
          if (mark.half_yearly_marks !== undefined && mark.half_yearly_marks !== null && mark.half_yearly_marks !== "") {
            markEntry.half_yearly_marks = Number(mark.half_yearly_marks);
          }
          if (mark.yearly_marks !== undefined && mark.yearly_marks !== null && mark.yearly_marks !== "") {
            markEntry.yearly_marks = Number(mark.yearly_marks);
          }

          if ('half_yearly_marks' in markEntry || 'yearly_marks' in markEntry) {
            studentsMarks.push(markEntry);
          }
        });
      }
    });

    let payload = {
      id: sectionData._id,
      school_id: sectionData.school_id,
      class_id: sectionData.class_id,
      section_id: sectionData.section_id,
      assessment_id: sectionData.assessment_id,
      students_marks: studentsMarks
    };

    this.setState({ loader: true });
    this.props.api.apiUpdateOfflineAssessmentSectionMarks({ id: sectionData._id }, payload)
      .then((res) => {
        this.setState({ loader: false });
        window.success("Marks updated successfully");
        this.fetchData();
      })
      .catch((err) => {
        this.setState({ loader: false });
        window.error("Failed to update marks");
      });
  };

  handleDownloadReport = (reportType) => {
    let term = "";
    if (reportType === "midYear") term = "Half Yearly";
    else if (reportType === "fullYear") term = "Yearly";

    let { data, selectedDownloadProfileId } = this.state;
    let sectionData = data?.offlineAssessmentSection || {};
    let sectionId = sectionData._id || (this.props.urlparams && this.props.urlparams.id);

    let params = {};

    if (term) {
      params.term = term;
    }

    if (selectedDownloadProfileId) {
      params.student_id = selectedDownloadProfileId;
    }

    this.setState({ loader: true });

    const handleSuccess = (resData, extraHeaders = {}) => {
      this.setState({ loader: false });
      const data = resData?.data || resData;
      const resHeaders = resData?.headers || extraHeaders;
      const blob = data instanceof Blob ? data : new Blob([data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      let academicYear = sectionData?.academic_year_id?.display_value || "Academic_Year";
      let filename = `student_reports_${academicYear}.zip`;
      if (selectedDownloadProfileId) {
        let student = this.state.data?.students?.find(s => s.profile_id === selectedDownloadProfileId);
        let studentName = student?.profile?.name || "Student";
        let termStr = term || "Term";
        filename = `report_${academicYear}_${studentName}_${selectedDownloadProfileId}_${termStr}.pdf`;
      }

      const contentDisposition = resHeaders && (
        resHeaders['content-disposition'] ||
        resHeaders['Content-Disposition'] ||
        (typeof resHeaders.get === 'function' ? resHeaders.get('content-disposition') : null)
      );

      if (contentDisposition) {
        let extractedFilename = "";
        const filenameStarMatch = contentDisposition.match(/filename\*=(?:UTF-8''|utf-8'')?([^;\r\n]+)/i);
        if (filenameStarMatch && filenameStarMatch[1]) {
          extractedFilename = decodeURIComponent(filenameStarMatch[1].replace(/^["']|["']$/g, ''));
        } else {
          const filenameMatch = contentDisposition.match(/filename=["']?([^"';\r\n]+)["']?/i);
          if (filenameMatch && filenameMatch[1]) {
            extractedFilename = filenameMatch[1].replace(/\r/g, '').trim();
          }
        }
        if (extractedFilename) {
          filename = extractedFilename;
          if (!/\.[a-zA-Z0-9]+$/.test(filename)) {
            filename = filename + (selectedDownloadProfileId ? '.pdf' : '.zip');
          }
        }
      }

      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      window.success("Report downloaded successfully");
    };

    const handleError = (err) => {
      this.setState({ loader: false });
      window.error("Failed to download report");
    };

    this.props.api.apiDownloadOfflineAssessmentSectionReport({ id: sectionId }, params)
      .then(res => {
        handleSuccess(res.data, res.headers);
      })
      .catch(handleError);
  };

  handleGenerateReport = (termValue) => {
    let { data, loader, isGeneratingReport } = this.state;
    if (loader || isGeneratingReport) return;
    if (!data || !data.offlineAssessmentSection) return;

    let sectionData = data.offlineAssessmentSection;
    let parameters = sectionData?.offline_assessment?.parameters || [];
    let students = data.students || [];

    let isComplete = true;
    let markField = termValue === "Half Yearly" ? "half_yearly_marks" : "yearly_marks";

    // Check if every student has a mark for every parameter
    for (let student of students) {
      for (let param of parameters) {
        let mark = student.marks?.find(m => m.parameter_id === param._id);
        if (!mark || mark[markField] === undefined || mark[markField] === null || mark[markField] === "") {
          isComplete = false;
          break;
        }
      }
      if (!isComplete) break;
    }

    if (!isComplete) {
      this.setState({ pendingReportTerm: termValue }, () => {
        // Open incomplete modal
        const btn = document.createElement('button');
        btn.setAttribute('data-bs-toggle', 'modal');
        btn.setAttribute('data-bs-target', '#incompleteAssessmentModal');
        document.body.appendChild(btn);
        btn.click();
        document.body.removeChild(btn);
      });
      return;
    }

    this.executeGenerateReport(termValue);
  };

  executeGenerateReport = (termValue) => {
    let { data, loader, isGeneratingReport } = this.state;
    if (loader || isGeneratingReport) return;
    if (!data || !data.offlineAssessmentSection) return;

    let sectionData = data.offlineAssessmentSection;
    let parameters = sectionData?.offline_assessment?.parameters || [];
    let students = data.students || [];

    let isComplete = true;
    let markField = termValue === "Half Yearly" ? "half_yearly_marks" : "yearly_marks";

    for (let student of students) {
      for (let param of parameters) {
        let mark = student.marks?.find(m => m.parameter_id === param._id);
        if (!mark || mark[markField] === undefined || mark[markField] === null || mark[markField] === "") {
          isComplete = false;
          break;
        }
      }
      if (!isComplete) break;
    }

    let payload = {
      id: sectionData._id,
      is_force_create: !isComplete,
      term: termValue || "Half Yearly or Yearly",
      school_id: sectionData.school_id,
      class_id: sectionData.class_id,
      section_id: sectionData.section_id,
      assessment_id: sectionData.assessment_id
    };

    this.setState({ loader: true, isGeneratingReport: true });
    this.props.api.apiGenerateOfflineAssessmentReport({ id: sectionData._id }, payload)
      .then((res) => {
        this.setState({
          loader: false,
          isGeneratingReport: false,
        });
        this.fetchData();

        // Open the scheduled modal
        const btn = document.createElement('button');
        btn.setAttribute('data-bs-toggle', 'modal');
        btn.setAttribute('data-bs-target', '#reportsScheduledModal');
        document.body.appendChild(btn);
        btn.click();
        document.body.removeChild(btn);
      })
      .catch((err) => {
        this.setState({ loader: false, isGeneratingReport: false });
        let message = err?.response?.data?.message || err?.response?.data?.issues?.error || "Failed to generate report";
        window.error(message);
      });
  };

  handleDownloadExcel = (e) => {
    e.preventDefault();
    let { data } = this.state;
    if (!data || !data.offlineAssessmentSection) return;

    let sectionData = data.offlineAssessmentSection;
    this.setState({ loader: true });

    this.props.api.apiDownloadOfflineAssessmentSectionExcel({ id: sectionData._id })
      .then(async (res) => {
        this.setState({ loader: false });
        if (res) {
          let blobData = await res;
          let blob = new Blob([blobData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute(
            "download",
            `Assessment_Scores_${sectionData.class?.class_id || "Class"}_${sectionData.section?.name || "Section"}.xlsx`
          );
          link.click();
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        window.error("Failed to download excel");
      });
  };

  renderParameterColumns(student, parameter, paramIndex) {
    let mark = student.marks?.find(m => m.parameter_id === parameter._id) || {};
    let sectionData = this.state.data?.offlineAssessmentSection || {};
    let isSuperAdmin = this.state.role === "SUPER_ADMIN";
    let isMidYearLocked = isSuperAdmin ? false : (sectionData.mid_year_status?.status === "LOCKED" || this.state.role === "SCHOOL_ADMIN");
    let isFullYearDisabled = isSuperAdmin ? false : (sectionData.full_year_status?.status === "LOCKED" ||
      sectionData.mid_year_status?.status === "IN_PROGRESS" ||
      sectionData.mid_year_status?.status === "PENDING" ||
      this.state.role === "SCHOOL_ADMIN");

    return (
      <React.Fragment key={paramIndex}>
        <td className="text-center px-1 py-2">
          <input
            type="text"
            className="form-control form-control-sm text-center mx-auto"
            value={mark.half_yearly_marks !== undefined && mark.half_yearly_marks !== null ? mark.half_yearly_marks : ""}
            onChange={(e) => this.handleMarkChange(student._id, parameter._id, 'half_yearly_marks', e.target.value)}
            style={{ width: '50px', backgroundColor: isMidYearLocked ? '#e9ecef' : '#fff' }}
            disabled={isMidYearLocked}
          />
        </td>
        <td className="text-center px-1 py-2">
          <input
            type="text"
            className="form-control form-control-sm text-center mx-auto"
            value={mark.yearly_marks !== undefined && mark.yearly_marks !== null ? mark.yearly_marks : ""}
            onChange={(e) => this.handleMarkChange(student._id, parameter._id, 'yearly_marks', e.target.value)}
            style={{ width: '50px', backgroundColor: isFullYearDisabled ? '#e9ecef' : '#fff' }}
            disabled={isFullYearDisabled}
          />
        </td>
        <td className="text-center px-1 py-2"><input type="text" className="form-control form-control-sm text-center mx-auto" value={mark.average_marks !== undefined && mark.average_marks !== null ? mark.average_marks : ""} disabled style={{ width: '50px', backgroundColor: '#e9ecef' }} /></td>
      </React.Fragment>
    );
  }

  getStudentTotalPercentage = (student, field, totalMaxMarks) => {
    let total = student[field];
    if (total === undefined || total === null || total === "") {
      let markField = field === 'total_half_yearly' ? 'half_yearly_marks' : 'yearly_marks';
      let hasAnyMark = false;
      let sum = 0;
      (student.marks || []).forEach(mk => {
        if (mk[markField] !== undefined && mk[markField] !== null && mk[markField] !== "" && !isNaN(Number(mk[markField]))) {
          sum += Number(mk[markField]);
          hasAnyMark = true;
        }
      });
      if (hasAnyMark) {
        total = sum;
      } else {
        return "";
      }
    }

    let numTotal = Number(total);
    if (isNaN(numTotal) || !totalMaxMarks || totalMaxMarks <= 0) return "";

    let percent = (numTotal / totalMaxMarks) * 100;
    return `${parseFloat(percent.toFixed(2))}%`;
  };

  render() {
    let { data, loader, selectedStudentIds, sortConfig, role } = this.state;

    let sectionData = data?.offlineAssessmentSection || {};
    let allStudents = data?.students || [];
    let students = allStudents;
    if (selectedStudentIds && selectedStudentIds.length > 0) {
      students = allStudents.filter(s => selectedStudentIds.includes(s.profile_id));
    }

    if (sortConfig.key) {
      students.sort((a, b) => {
        let aVal = 0, bVal = 0;
        if (sortConfig.key === 'student_name') {
          aVal = (a.profile?.name || a.profile_id || '').toLowerCase();
          bVal = (b.profile?.name || b.profile_id || '').toLowerCase();
        } else if (sortConfig.key === 'total_half_yearly' || sortConfig.key === 'total_yearly') {
          aVal = a[sortConfig.key] || 0;
          bVal = b[sortConfig.key] || 0;
        } else if (sortConfig.key === 'half_yearly' || sortConfig.key === 'yearly') {
          let aMark = a.marks?.find(m => m.parameter_id === sortConfig.parameterId);
          let bMark = b.marks?.find(m => m.parameter_id === sortConfig.parameterId);
          aVal = aMark && aMark[`${sortConfig.key}_marks`] !== null && aMark[`${sortConfig.key}_marks`] !== undefined ? Number(aMark[`${sortConfig.key}_marks`]) : -Infinity;
          bVal = bMark && bMark[`${sortConfig.key}_marks`] !== null && bMark[`${sortConfig.key}_marks`] !== undefined ? Number(bMark[`${sortConfig.key}_marks`]) : -Infinity;
        }

        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    let parameters = sectionData?.offline_assessment?.parameters || [];
    let totalMaxMarks = parameters.reduce((sum, param) => sum + (Number(param.maxMark) || 0), 0);
    let headerTitle = "Loading...";
    if (data) {
      headerTitle = `${sectionData.class?.curriculum?.curriculum_name || sectionData.class?.class_id || "Class"} - ${sectionData.section?.name || "Section"} - ${sectionData.academic_year_id?.display_value || ""}`;
    }

    let isAllLocked = sectionData.mid_year_status?.status === "LOCKED" && sectionData.full_year_status?.status === "LOCKED";
    let isSuperAdmin = role === "SUPER_ADMIN" || localStorage.getItem("currentAdminRole") === "SUPER_ADMIN";
    let isCoordinator = role === "SCHOOL_COORDINATOR" || localStorage.getItem("currentAdminRole") === "SCHOOL_COORDINATOR";

    let isSaveDisabled = isSuperAdmin ? false : isAllLocked;
    let isGenerateDisabled = isSuperAdmin ? false : isAllLocked;
    let isReportDownloadable = isAllLocked;

    let isMidYearLocked = isCoordinator && (sectionData.mid_year_status?.status === "LOCKED" || sectionData.mid_year_status === "LOCKED");
    let isFullYearLocked = isCoordinator && (sectionData.full_year_status?.status === "LOCKED" || sectionData.full_year_status === "LOCKED");

    return (
      <LayoutWrapper
        title={headerTitle !== "Loading..." ? headerTitle : "Assessment Management"}
        back="Assessment Management"
        backlink="/assessmanagement"
        endname={true}
        headerRight={
          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center gap-2">
              <style>{`
                .react-dropdown-select-clear {
                  font-size: 24px !important;
                }
              `}</style>
              <label className="fw-bold mb-0 text-nowrap" style={{ fontSize: '13px' }}>Student Name:</label>
              <div style={{ minWidth: '250px' }}>
                <Select
                  options={allStudents.map(s => ({
                    value: s.profile_id,
                    label: s.profile?.name || s.profile_id
                  }))}
                  searchable={true}
                  multi={true}
                  placeholder="Select Student"
                  dropdownHeight="220px"
                  clearable={true}
                  onChange={(values) => {
                    this.setState({ selectedStudentIds: values ? values.map(v => v.value) : [] });
                  }}
                  style={{ minHeight: '31px', fontSize: '13px', borderRadius: '0.25rem', borderColor: '#dee2e6', padding: '0 8px' }}
                  contentRenderer={({ props, state, methods }) => (
                    <div style={{ display: 'flex', flex: 1, width: '100%', alignItems: 'center' }}>
                      <input
                        type="text"
                        value={state.search}
                        onChange={methods.setSearch}
                        placeholder={state.values.length > 0 ? `${state.values.length} Selected` : "Select Student"}
                        style={{ border: 'none', outline: 'none', background: 'transparent', width: '100%', fontSize: '13px' }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="dropdown">
              <button className="btn btn-warning text-white fw-bold dropdown-toggle" type="button" id="downloadDropdown" data-bs-toggle="dropdown" aria-expanded="false" style={{ backgroundColor: '#ff9800', borderColor: '#ff9800' }}>
                <i className="la la-download me-2"></i> Download
              </button>
              <ul className="dropdown-menu dropdown-menu-end shadow" aria-labelledby="downloadDropdown">
                <li><a className="dropdown-item py-2" href="#" onClick={this.handleDownloadExcel}>Table as excel</a></li>
                <li><a className="dropdown-item py-2" href="#" data-bs-toggle="modal" data-bs-target="#downloadReportModal" onClick={() => this.setState({ selectedDownloadProfileId: null })}>All students report</a></li>
              </ul>
            </div>
          </div>
        }
      >
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <div className="card shadow-sm border-0 mb-4 no-hover-card">
          <div className="card-body p-0">
            <style>{`
              .assess-table tbody tr { background-color: #fff !important; }
              .assess-table tbody tr td { background-color: #fff !important; vertical-align: middle; }
              .assess-table tbody tr:hover { background-color: #f9f9f9 !important; }
              .assess-table tbody tr:hover td { background-color: #f9f9f9 !important; }
              .assess-table th { font-size: 13px; font-weight: 600; }
              .sort-icon { margin-left: 5px; font-size: 14px; vertical-align: middle; }
              .no-hover-card:hover {
                border: 0 !important;
                box-shadow: 0 .125rem .25rem rgba(0,0,0,.075) !important;
                transform: none !important;
                background-color: #fff !important;
              }
            `}</style>
            <div className="table-responsive" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <table className="table table-bordered align-middle mb-0 assess-table" style={{ minWidth: `${180 + (parameters.length * 150) + 150}px` }}>
                <thead className="sticky-top bg-white" style={{ zIndex: 1 }}>
                  <tr>
                    <th rowSpan="3" className="align-middle text-center text-white border-end" style={{ backgroundColor: '#16223e', width: '180px', cursor: 'pointer' }} onClick={() => this.requestSort('student_name')}>
                      Students <i className={`la la-arrow-${sortConfig.key === 'student_name' && sortConfig.direction === 'desc' ? 'down' : 'up'} sort-icon`}></i>
                    </th>
                    {parameters.length > 0 && <th colSpan={parameters.length * 3} className="text-center text-white py-2 border-bottom-0" style={{ backgroundColor: '#1eb57b' }}>Parameters</th>}
                    <th rowSpan="2" colSpan="2" className="align-middle text-center text-white py-2 border-bottom-0" style={{ backgroundColor: '#16223e' }}>Total For {totalMaxMarks}</th>
                    <th rowSpan="3" className="align-middle text-center bg-white border-0" style={{ width: '50px' }}></th>
                  </tr>
                  <tr>
                    {parameters.map((param, i) => {
                      let color = this.paramColors[i % this.paramColors.length];
                      return (
                        <th key={i} colSpan="3" className="text-center py-2 border-end" style={{ backgroundColor: color.bg, color: color.text }}>
                          {param.name}<br />
                          <span style={{ fontSize: '11px', fontWeight: 'normal' }}>(Maximum {param.maxMark} marks)</span>
                        </th>
                      )
                    })}
                  </tr>
                  <tr className="bg-light">
                    {parameters.map((param, i) => {
                      let color = this.paramColors[i % this.paramColors.length];
                      return (
                        <React.Fragment key={i}>
                          <th className="text-center py-2 border-top-0" style={{ backgroundColor: color.colBg, cursor: 'pointer' }} onClick={() => this.requestSort('half_yearly', param._id)}>Mid Year <i className={`la la-arrow-${sortConfig.key === 'half_yearly' && sortConfig.parameterId === param._id && sortConfig.direction === 'desc' ? 'down' : 'up'} sort-icon`}></i></th>
                          <th className="text-center py-2 border-top-0" style={{ backgroundColor: color.colBg, cursor: 'pointer' }} onClick={() => this.requestSort('yearly', param._id)}>Full Year <i className={`la la-arrow-${sortConfig.key === 'yearly' && sortConfig.parameterId === param._id && sortConfig.direction === 'desc' ? 'down' : 'up'} sort-icon`}></i></th>
                          <th className="text-center py-2 border-top-0" style={{ backgroundColor: color.colBg }}>Average</th>
                        </React.Fragment>
                      )
                    })}
                    {/* Total For max marks */}
                    <th className="text-center text-white py-2 border-top-0" style={{ backgroundColor: '#263352', cursor: 'pointer', minWidth: '85px' }} onClick={() => this.requestSort('total_half_yearly')}>Mid Year <i className={`la la-arrow-${sortConfig.key === 'total_half_yearly' && sortConfig.direction === 'desc' ? 'down' : 'up'} sort-icon text-white`}></i></th>
                    <th className="text-center text-white py-2 border-top-0" style={{ backgroundColor: '#263352', cursor: 'pointer', minWidth: '85px' }} onClick={() => this.requestSort('total_yearly')}>Full Year <i className={`la la-arrow-${sortConfig.key === 'total_yearly' && sortConfig.direction === 'desc' ? 'down' : 'up'} sort-icon text-white`}></i></th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student, index) => (
                    <tr key={index} className="bg-white">
                      <td className="fw-bold px-3 py-2" style={{ fontSize: "13px" }}>{student.profile?.name || student.profile_id}</td>
                      {parameters.map((param, paramIndex) => this.renderParameterColumns(student, param, paramIndex))}
                      <td className="text-center px-1 py-2"><input type="text" className="form-control form-control-sm text-center mx-auto" value={this.getStudentTotalPercentage(student, 'total_half_yearly', totalMaxMarks)} disabled style={{ width: '75px', backgroundColor: '#e9ecef', padding: '0.25rem 4px' }} /></td>
                      <td className="text-center px-1 py-2"><input type="text" className="form-control form-control-sm text-center mx-auto" value={this.getStudentTotalPercentage(student, 'total_yearly', totalMaxMarks)} disabled style={{ width: '75px', backgroundColor: '#e9ecef', padding: '0.25rem 4px' }} /></td>
                      <td className="text-center border-0 bg-white px-2 py-2">
                        <div className="dropdown">
                          <a href="#" className="text-dark" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="fa fa-ellipsis-v" style={{ fontSize: "18px", color: "#666" }}></i>
                          </a>
                          <ul className="dropdown-menu dropdown-menu-end shadow border-0" style={{ minWidth: '120px' }}>
                            <li>
                              <a className="dropdown-item py-2 d-flex align-items-center" href="#" data-bs-toggle="modal" data-bs-target="#downloadReportModal" onClick={() => this.setState({ selectedDownloadProfileId: student.profile_id })}>
                                <i className="la la-download me-2" style={{ fontSize: "16px" }}></i> Report
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {students.length === 0 && !loader && (
                    <tr><td colSpan={parameters.length * 3 + 4} className="text-center py-4">No students found.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end gap-3 py-3">
          <button className="btn btn-light border px-4 fw-bold text-secondary" onClick={() => window.history.back()}>Cancel</button>

          {role !== "SCHOOL_ADMIN" && (
            <React.Fragment>
              <button
                className="btn btn-warning text-white px-5 fw-bold"
                onClick={isSaveDisabled ? undefined : this.handleSave}
                disabled={isSaveDisabled}
                style={{
                  backgroundColor: isSaveDisabled ? '#ccc' : '#ffb300',
                  borderColor: isSaveDisabled ? '#ccc' : '#ffb300',
                  cursor: isSaveDisabled ? 'not-allowed' : 'pointer'
                }}
              >
                Save
              </button>
              <button
                className="btn text-white px-4 fw-bold"
                data-bs-toggle={isGenerateDisabled ? "" : "modal"}
                data-bs-target={isGenerateDisabled ? "" : "#selectYearModal"}
                disabled={isGenerateDisabled}
                style={{
                  backgroundColor: isGenerateDisabled ? '#ccc' : '#ffb300',
                  borderColor: isGenerateDisabled ? '#ccc' : '#ffb300',
                  cursor: isGenerateDisabled ? 'not-allowed' : 'pointer'
                }}
              >
                Ready to Generate Report
              </button>
            </React.Fragment>
          )}
        </div>

        <DownloadReportModal
          id="downloadReportModal"
          onDownload={this.handleDownloadReport}
          isMidYearReportGenerated={sectionData?.mid_year_status?.is_report_generated}
          isFullYearReportGenerated={sectionData?.full_year_status?.is_report_generated}
        />
        <SelectYearModal
          id="selectYearModal"
          onConfirm={this.handleGenerateReport}
          isMidYearLocked={isMidYearLocked}
          isFullYearLocked={isFullYearLocked}
          isGenerating={this.state.loader || this.state.isGeneratingReport}
        />
        <IncompleteAssessmentModal
          id="incompleteAssessmentModal"
          termLabel={this.state.pendingReportTerm === "Half Yearly" ? "Mid-Year" : "Full-Year"}
          onConfirm={() => this.executeGenerateReport(this.state.pendingReportTerm)}
        />
        <ReportsScheduledModal id="reportsScheduledModal" />
      </LayoutWrapper>
    );
  }
}

export default connect(ViewEditScore);
